import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {GlobalModule} from "../global/global.module";
import {PengisianDataPribadiBsiRoutingModule} from "./pengisian-data-pribadi-bsi-routing.module";
import {PengisianDataPribadiBsiComponent} from "./pengisian-data-pribadi-bsi.component";



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    PengisianDataPribadiBsiRoutingModule,
    GlobalModule
  ],
  declarations: [
    PengisianDataPribadiBsiComponent
  ]
})
export class PengisianDataPribadiBsiModule { }
